import { memo } from 'react';
import { Link } from '@/hen-ui/atomics/Link';
import { Image } from '@/hen-ui/atomics/Image';
import type { NavItem } from './types';
import { FOCUS_RING } from './subnav.constants';

interface FeaturedContentCardProps {
  item: NavItem;
}

export const FeaturedContentCard = memo(function FeaturedContentCard({
  item,
}: FeaturedContentCardProps) {
  const card = item.featuredCard;
  const imageAlt = card?.imageAlt ?? item.label;

  return (
    <Link
      href={item.uri}
      underline='none'
      underlineStyle='thin'
      className={`group flex gap-sm no-underline ${FOCUS_RING}`}
    >
      <div className='w-subnav-thumbnail min-h-subnav-thumbnail flex-shrink-0 overflow-hidden rounded-sm bg-neutral-500'>
        {card?.imageUrl && (
          <Image
            src={card.imageUrl}
            alt={imageAlt}
            objectFit='cover'
            className='h-full'
            loading='lazy'
          />
        )}
      </div>
      <div className='flex min-w-0 flex-col justify-center gap-xxs'>
        {card?.category && (
          <span className='text-l1 font-bold text-secondary-700 md:text-b5'>
            {card.category}
          </span>
        )}
        <span className='line-clamp-2 text-b4 font-bold text-heading group-hover:text-secondary-700 md:text-h4'>
          {item.label}
        </span>
        {(card?.author || card?.date) && (
          <span className='text-l1 text-neutral-500'>
            {card.author && `By ${card.author}`}
            {card.author && card.date && ' \u00B7 '}
            {card.date ?? ''}
          </span>
        )}
      </div>
    </Link>
  );
});
